module.exports = __webpack_public_path__ + "img/广告-5 - 巧借东风.c61d68e4.jpg";